import DataTile from "./DataTile";
import SendSharpIcon from '@material-ui/icons/SendSharp';
import { fetchCampaignsAction} from "../../../actions";
import React from "react";
import {useSelector} from "react-redux";

const Tile = (props) => {

    const {customerId} = props;

    /**************************/
    /*Setup State and Dispatch*/
    /**************************/
    const {customerInView} = useSelector(({customer}) => customer);

    const customerIdToUse = customerId ? customerId : customerInView;

    const valueFunction = (stateData) => stateData
        ? stateData[customerIdToUse]
            ? stateData[customerIdToUse].total_phishing_attacks !== null
                ? stateData[customerIdToUse].total_phishing_attacks
                : null
            : null
        : null;

    return (
        <DataTile
            color="light"
            subTitle="Phishing Attacks"
            tipText={"Total number of phishing attacks launched across all campaigns. A phishing attack is an action taken during a phishing campaign vector."}
            icon={<SendSharpIcon style={{fontSize: "70px"}}/>}
            stateName="customer"
            stateElement="metaCampaigns"
            // useDeepDataStore
            // dontFetch
            // deepDataStore = {(dataStore) => dataStore? dataStore[customerIdToUse] ? dataStore[customerIdToUse].metaCampaigns : null : null}
            stateLoaderName="loadingCampaigns"
            stateLoaderError="loadingCampaignsError"
            stateFetchAction={fetchCampaignsAction({
                customerId: customerIdToUse
            })}
            preventDataFetchConditionFunction={(dataStore) => !customerIdToUse}
            valueFunction={valueFunction}
            requiresModule={"social"}
        />
    )

}

export default Tile;